const pageOp = {
  opNo: 'ButtonCode',
  opName:'ButtonName',
  opType:'ButtonType',
  remark:'Remark',
  commonType:'CommonButton',
  customType:'CustomButton',
  msg:{
    opNo:'Please input the ButtonCode',
    opName:"Please input the ButtonName",
    opType:"Please select the OpType"
  }
};
export default pageOp



// WEBPACK FOOTER //
// ./src/page/auth/pageOp/lang/pageOp.en.js